<!--sidebar-->
<c-sidebar #sidebar1="cSidebar" class="d-print-none sidebar sidebar-fixed bg-primary border-end app-sidebar"
  colorScheme="dark" id="sidebar1" visible>
  <c-sidebar-header>
    <img src="assets/img/polpaico-full-logo.svg" alt="Logo Maestro Polpaico" class="login-logo mb-4" style="width: 100%;" />
  </c-sidebar-header>

  <ng-scrollbar #scrollbar="ngScrollbar" (updated)="onScrollbarUpdate(scrollbar.state)" class="overflow"
    pointerEventsMethod="scrollbar" visibility="hover">
    <c-sidebar-nav #overflow [navItems]="navItems" dropdownMode="close" compact />
  </ng-scrollbar>
</c-sidebar>
<div class="wrapper d-flex flex-column min-vh-100">
  <app-default-header [cShadowOnScroll]="'sm'" class="mb-4 d-print-none header header-sticky p-0 shadow-sm"
    position="sticky" sidebarId="sidebar1" (logoutClicked)="toggleLogoutModal()" />
  <div class="body flex-grow-1">
    <c-container fluid class="h-auto py-4" style="padding-right: 2.5rem !important; padding-left: 2.5rem !important;">
      <router-outlet />
    </c-container>
  </div>
</div>


<c-modal backdrop="static" [visible]="logoutModalVisible" (visibleChange)="handleLogoutModalVisibleChange($event)">

  <c-modal-header>
    <h5 cModalTitle class="text-danger fw-bold mb-0">¿Cerrar sesión?</h5>
    <button (click)="toggleLogoutModal()" cButtonClose></button>
  </c-modal-header>

  <c-modal-body class="text-body-secondary">
    Estás a punto de cerrar tu sesión. ¿Estás seguro de que deseas continuar?
  </c-modal-body>

  <c-modal-footer>
    <button (click)="toggleLogoutModal()" cButton color="secondary" class="px-4">
      Cancelar
    </button>
    <button (click)="confirmLogout()" cButton color="danger" class="px-4">
      Cerrar sesión
    </button>
  </c-modal-footer>
</c-modal>